import React from 'react'
import { useExercise } from '../ExerciseProvider'
import { Textarea } from '~/lib/ui/textarea'
import { useTranslation } from '../../../hooks/useTranslation'

const QuestionField = ({ label, value, onChange }) => (
  <div className="mb-6 font-roboto text-base font-medium">
    <div className="flex flex-col">
      <label className="!mb-1">{label}</label>
      <Textarea
        className="min-h-[125px] w-full rounded-[20px]"
        onChange={onChange}
        value={value || ''}
      />
    </div>
  </div>
)

const FriendListPageTwo = ({ questions }) => {
  const { handleChange, getResponse, exerciseIndex, formattedExerciseName } =
    useExercise()
  const { t } = useTranslation(formattedExerciseName)
  const pageTwoTranslations = t('pages.1')

  const handleFieldChange = (field) => (e) =>
    handleChange(exerciseIndex, field, e)

  return (
    <>
      <QuestionField
        label={pageTwoTranslations.strong_relationship}
        value={getResponse(exerciseIndex, 'strong_relationship')}
        onChange={handleFieldChange('strong_relationship')}
      />
      <p>{pageTwoTranslations.ask_yourself}</p>
      <div className="questions">
        {questions.map((question, index) => (
          <QuestionField
            key={index}
            label={question.question}
            value={getResponse(exerciseIndex, question.slug)}
            onChange={handleFieldChange(question.slug)}
          />
        ))}
      </div>
    </>
  )
}

export default FriendListPageTwo
